import { useTranslation } from 'next-i18next';
import { memo } from 'react';
import ComponentWrapper from '../../common/ContentWrapper';
import ImageWithFallback from '../../common/ImageWithFallback';
import type SupportBannerType from '../../../../types/SupportBanner';

type Props = {
  supportBanner: SupportBannerType;
};

const SupportBanner = ({ supportBanner }: Props) => {
  const { t } = useTranslation('home');

  return (
    <ComponentWrapper className="pb-14 pt-12 sm:pb-20 sm:pt-16">
      <h2 className="app-section-title hidden sm:block">{t('customer_support.title')}</h2>
      <div data-testid="support-banner">
        <div className="relative hidden sm:block">
          <ImageWithFallback
            alt={supportBanner.desktopImage?.altText || 'support-banner-desktop'}
            src={supportBanner.desktopImage?.url || '/fallback-img-1440x440.png'}
            url={supportBanner.url}
            objectFit="cover"
            layout="responsive"
            width={supportBanner.desktopImage?.width}
            height={supportBanner.desktopImage?.height}
            fallbackSrc="/fallback-img-1440x440.png"
          />
        </div>
        <div className="relative sm:hidden">
          <ImageWithFallback
            alt={supportBanner.mobileImage?.altText || 'support-banner-mobile'}
            src={supportBanner.mobileImage?.url || '/fallback-img-3704x2304.png'}
            url={supportBanner.url}
            objectFit="cover"
            layout="responsive"
            width={supportBanner.mobileImage?.width}
            height={supportBanner.mobileImage?.height}
            fallbackSrc="/fallback-img-3704x2304.png"
          />
        </div>
      </div>
    </ComponentWrapper>
  );
};

export default memo(SupportBanner);
